import app_img from '@/public/article/App.webp';
import managment_img from '@/public/article/Customer management.webp';
import invoicing from '@/public/article/Invoice.webp';
import orders_img from '@/public/article/Orders.webp';
import article1 from '@/public/article/picture.webp';
import schedule_img from '@/public/article/Schedule_1.webp';
import image4 from '@/public/industries/hvac/Reporting-and-analytics.webp';
import review1 from '@/public/reviews/CapterraSvg.svg';
import review2 from '@/public/reviews/GetAppSvg.svg';
import review3 from '@/public/reviews/SoftwareAdvice.svg';
import { ArticleType } from '@/types/articles';
import { IRoutePath } from '@/types/router';

const faq = [
  {
    title: 'How can software grow an HVAC business?',
    text: 'Implementing HVAC software can enhance efficiency through better HVAC software for field service management. It streamlines scheduling, offers customer relationship insights, and optimizes operations, all of which can lead to growth with the help of HVAC software for small businesses.',
  },
  {
    title: 'Does your HVAC business software have a mobile app?',
    text: 'Our HVAC business software includes the best app for HVAC business, enabling technicians to manage jobs and clients directly from their mobile devices, ensuring flexibility and real-time updates.',
  },
  {
    title: 'How much does HVAC software cost?',
    text: 'HVAC software cost varies, often available through a monthly or annual subscription model. Prices are tailored based on features and the size of the HVAC business, ensuring a scalable investment.',
  },
  {
    title: 'How can HVAC service software help my business?',
    text: 'HVAC service management software provides scheduling, job tracking, and customer management tools, which can significantly improve operational efficiency and customer satisfaction, leading to increased revenue and business growth.',
  },
];

const testimonals = [
  {
    text: 'With Orcatec, our response times have improved dramatically. Customers notice, and our reviews are better than ever!',
    name: 'Alexa Smith,',
    position: 'Operations Manager, CoolTech HVAC',
  },
  {
    text: ' Orcatec’s training and support was fantastic, me and my team were able to start using the software in no time.',
    name: ' Jordan S.,',
    position: 'Owner of Roofing Company',
  },
  {
    text: `The scheduling feature alone makes Orcatec indispensable. We've cut down on double bookings and can handle more clients efficiently.`,
    name: ' Maria Gonzalez,',
    position: ' Service Coordinator, QuickFix HVAC',
  },
  {
    text: ' It’s easy to use. We quickly switched from our previous software and started using Orcatec. Great functionality at an extremely affordable cost.',
    name: ' Oscar W.,',
    position: 'Owner of Plumbing Company',
  },

  {
    text: ' Orcatec helped us sort out all our questions and solved many of our problems. I can say with confidence that this platform is a salvation for people who want not to step on different rakes and immediately do everything with high quality',
    name: ' Lars L.,',
    position: 'Owner of Electric Service',
  },

  {
    text: `Orcatec's analytics transformed how we manage finances. We're not just a service company but a growing, strategic enterprise.`,
    name: ' James Lee CFO,,',
    position: 'EfficientFlow Solutions',
  },
];

const industries = {
  title: 'Our industries',
  description: `Explore Orcatec's blog for expert insights, strategies, and industry news to maximize the potential of HVAC business management software, from enhancing competitiveness to streamlining operations and staying informed about regulatory changes.`,
  items: [
    { title: 'HVAC', path: IRoutePath.INDUSTRIES_HVAC },
    { title: 'Plumbing', path: IRoutePath.INDUSTRIES_PLUMBING },
    { title: 'Appliance Repair', path: IRoutePath.INDUSTRIES_APPLIANCE },
    { title: 'Electrician', path: IRoutePath.INDUSTRIES_ELECTRICIAN },
    { title: 'Garage Door', path: IRoutePath.INDUSTRIES_GARAGE_DOOR },
    {
      title: 'Construction',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Property Maintenance',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Junk Removal',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Home Cleaning',
      path: IRoutePath.INDUSTRIES_HOME_CLEANING,
    },
    {
      title: 'Handyman',
      path: IRoutePath.INDUSTRIES_HANDYMAN,
    },
    {
      title: 'Landscaping and Lawn',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Construction',
      path: IRoutePath.INDUSTRIES_CONSTRUCTION,
    },

    {
      title: 'Home Renovation',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Automotive',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Pest Control',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Custom Home Building',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Custom Home Building',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Window Cleaning',
      path: IRoutePath.INDUSTRIES,
    },

    {
      title: 'Carpet Cleaning',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Pool and Spa Service',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Locksmith',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Fireplace and Chimney',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Roofing',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Water Treatment',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Alarm and Security',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Irrigation',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Painting Contractors',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Fire Safety',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Computer Service',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Moving',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Snow Removal',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Snow Removal',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Air Duct Cleaning',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Remodeling',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Janitorial Services',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Excavation',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Demolition Contractor',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Tree Care',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Restoration',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Flooring',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Tiling',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Drywall',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Pressure Washing',
      path: IRoutePath.INDUSTRIES,
    },
  ],
};

const articles = {
  title: `Software Features Made for HVAC Businesses`,
  items: [
    {
      type: ArticleType.VERICAL,
      image: {
        path: schedule_img,
        alt: 'Optimize Field Operations',
      },
      href: '#',
      tag: 'Scheduling and dispatch',
      title: 'Optimize Field Operations',
      text: 'Our Scheduling and Dispatch system significantly enhances operational efficiency by automating the scheduling process. It ensures timely service appointments and deliveries, contributing to a seamless customer experience.',
      list: [
        { text: 'Automates the scheduling process.' },
        { text: 'Dispatches technicians based on location and availability.' },
        { text: 'Optimizes routes for efficient travel.' },
        { text: 'Manages service appointments for timely deliveries.' },
      ],
    },

    {
      type: ArticleType.VERICAL,
      image: {
        path: managment_img,
        alt: 'Customer management',
      },
      href: '#',
      tag: 'Customer management',
      title: 'Build Lasting Relationships',
      text: 'The Customer Management feature is designed to strengthen customer relationships and elevate service quality. With tools for customer engagement and feedback, we ensure a customer-centric approach to every interaction.',
      list: [
        { text: 'Maintains comprehensive customer records.' },
        { text: 'Tracks service history for each customer.' },
        { text: 'Manages ongoing communication and follow-ups.' },
        { text: 'Provides tools for customer engagement and feedback.' },
      ],
    },

    {
      type: ArticleType.HORIZONTAL,
      image: {
        path: invoicing,
        alt: 'Invoicing and payments',
      },
      href: '#',
      tag: 'Invoicing and payments',
      title: 'Simplify Financial Transactions',
      text: 'Streamlining financial processes, our Invoicing and Payments module simplifies the creation and distribution of invoices.',

      list: [
        { text: 'Simplifies the creation and distribution of invoices.' },
        { text: 'Facilitates easy and secure payment processing.' },
        { text: 'Integrates with accounting software for financial tracking.' },
        { text: 'Offers various payment methods to customers.' },
      ],
    },

    {
      type: ArticleType.VERICAL,
      image: {
        path: image4.src,
        alt: 'Customer management',
      },
      href: '#',
      tag: 'Reporting and analytics',
      title: 'Make Decision by Data-Driven',
      text: 'Our Reporting and Analytics tool provides valuable insights into business operations, aiding in strategic decision-making. We empower your team with the information needed for effective and informed business planning.',
      list: [
        { text: 'Generates reports on key performance metrics.' },
        { text: 'Analyzes data for trend identification.' },
        { text: 'Provides dashboards for real-time performance monitoring.' },
        { text: 'Supports data-driven business planning.' },
      ],
    },

    {
      type: ArticleType.VERICAL,
      image: {
        path: orders_img,
        alt: 'Equipment orders',
      },
      href: '#',
      tag: 'Equipment orders',
      title: 'Enhancing Client Proposals',
      text: 'The Equipment Orders feature elevates client proposals by offering comparative equipment options. It facilitates direct ordering and tracking of equipment, ensuring accuracy and transparency in the proposal process.',
      list: [
        { text: 'Allows for the creation of detailed equipment estimates.' },
        {
          text: 'Integrates with inventory management for real-time availability.',
        },
        { text: 'Facilitates direct ordering and tracking of equipment.' },
      ],
    },
  ],
};

const intro = {
  tag: 'HVAC Business Software',
  title: {
    first_part: 'Upgrade Your Business with',
    second_part: 'Orcatec HVAC Software',
  },
  description:
    'Maximize efficiency and profitability with our cutting-edge HVAC management software. Designed for the modern HVAC service provider, our platform streamlines every aspect of your operations. Take the first step towards optimizing your HVAC services.',
  info: [
    { title: '40 hours', description: 'Reduced Monthly Paperwork' },
    { title: '30%', description: 'Increase in Customer Retention' },
  ],
};

const fullArticle1 = {
  image: {
    path: article1,
    alt: 'What is HVAC Business Software?',
  },
  title: 'What is HVAC Business Software?',
  description: `HVAC company software refers to specialized software solutions designed for managing and facilitating operations in the Heating, Ventilation, and Air Conditioning (HVAC) industry.
  Orcatec's HVAC software offers a comprehensive suite of features tailored to the HVAC industry. Key functionalities include:`,
  item: [
    {
      title: 'Scheduling',
      description: 'Efficient scheduling of technicians to reduce travel time',
    },
    {
      title: 'Task Management',
      description:
        'Includes handling a work order, permit management, and task tracking',
    },
    {
      title: 'Pricing and Commissions',
      description:
        'Offers various pricing options and automates commission calculations',
    },
    {
      title: 'Financial Management',
      description:
        'This encompasses financing options, mobile payments, and profit and loss analysis tools',
    },
  ],
};

const fullArticle2 = {
  image: {
    path: app_img,
    alt: 'Why HVAC Contractors Choosing Orcatec?',
  },
  title: 'Why HVAC Contractors Choosing Orcatec?',
  description: `Our software is designed to empower your business with a range of advantages, including beneficial opportunities that lead to your success:`,
  item: [
    {
      title: '',
      description:
        'Access essential software features without initial financial commitment with a free starter package.',
    },
    {
      title: '',
      description:
        'Enjoy the freedom to select and pay for only the functionalities that align with specific needs, ensuring cost-effectiveness.',
    },
    {
      title: '',
      description:
        'Tailor the software to unique business requirements through easy customization, including custom forms, workflows, and reports.',
    },
    {
      title: '',
      description: `Manage business operations from any device, whether it's a PC, tablet, or mobile phone, for enhanced convenience and efficiency.`,
    },

    {
      title: '',
      description: `Utilize the software on preferred devices, regardless of their operating system, with compatibility for iOS and Android.`,
    },
  ],
};

const reviews = {
  title: 'Our Reviews',
  items: [
    { path: review1.src, width: review1.width, alt: 'Capterra' },
    { path: review2.src, width: review2.width, alt: 'GetApp' },
    { path: review3.src, width: review3.width, alt: 'Software Advice' },
  ],
};

const blog = {
  title: 'Our Blog',
  description: `Explore Orcatec's blog for expert insights, strategies, and industry news to maximize the potential of HVAC business management software, from enhancing competitiveness to streamlining operations and staying informed about regulatory changes.`,
};

const bookDemo = {
  title: 'Book a Free Demo',
  description: `Book a free demo to unlock the full potential of our software for HVAC contractors! Orcatec team is here to guide you. Fill out the form below to receive expert consultation. Don’t miss this opportunity to transform your HVAC business with Orcatec's cutting-edge solutions, specially designed for HVAC contractors!`,
};

export {
  reviews,
  fullArticle2,
  fullArticle1,
  intro,
  articles,
  industries,
  testimonals,
  faq,
  blog,
  bookDemo,
};
